<template>
  <div class="row">
    <div class="col-md-4" v-for="(widget, index) in widgets" :key="index">
      <div class="card">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-grow-1">
              <p class="text-truncate font-size-14 mb-2">{{ widget.title }}</p>
              <h4 class="mb-0" :class="widget.valueClass">{{ widget.value }}</h4>
            </div>
            <div :class="widget.iconClass">
              <i :class="`${widget.icon} font-size-24`"></i>
            </div>
          </div>
        </div>

        <div class="card-body border-top py-3">
          <div class="text-truncate">
            <span :class="widget.badgeClass">
              <i :class="widget.badgeIcon"></i>
              {{ widget.status }}
            </span>
            <span class="text-muted ms-2">{{ widget.description }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusWidgets',
  props: {
    systemStatus: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    widgets() {
      const status = this.systemStatus;
      
      return [
        {
          title: "API Status",
          value: status.status || "OK",
          icon: "ri-server-line",
          iconClass: status.status === "OK" ? "text-success" : "text-danger",
          valueClass: status.status === "OK" ? "text-success" : "text-danger",
          badgeClass: status.status === "OK" ? "badge bg-soft-success font-size-11" : "badge bg-soft-danger font-size-11",
          badgeIcon: status.status === "OK" ? "mdi mdi-check-circle" : "mdi mdi-alert-circle",
          status: status.status === "OK" ? "Online" : "Offline",
          description: " Sistema principal"
        },
        {
          title: "PACS",
          value: status.systems?.orthanc_status || "Unknown",
          icon: "ri-database-2-line",
          iconClass: this.getStatusColor(status.systems?.orthanc_status),
          valueClass: this.getStatusColor(status.systems?.orthanc_status),
          badgeClass: this.getBadgeClass(status.systems?.orthanc_status),
          badgeIcon: this.getBadgeIcon(status.systems?.orthanc_status),
          status: this.getStatusText(status.systems?.orthanc_status),
          description: " Servidor DICOM"
        },
        {
          title: "Banco de Dados",
          value: status.systems?.database_status || "Unknown",
          icon: "ri-hard-drive-2-line",
          iconClass: this.getStatusColor(status.systems?.database_status),
          valueClass: this.getStatusColor(status.systems?.database_status),
          badgeClass: this.getBadgeClass(status.systems?.database_status),
          badgeIcon: this.getBadgeIcon(status.systems?.database_status),
          status: this.getStatusText(status.systems?.database_status),
          description: " PostgreSQL"
        }
      ];
    }
  },
  methods: {
    getStatusColor(status) {
      switch(status) {
        case 'online': return 'text-success';
        case 'offline': return 'text-danger';
        case 'warning': return 'text-warning';
        default: return 'text-muted';
      }
    },
    
    getBadgeClass(status) {
      switch(status) {
        case 'online': return 'badge bg-soft-success font-size-11';
        case 'offline': return 'badge bg-soft-danger font-size-11';
        case 'warning': return 'badge bg-soft-warning font-size-11';
        default: return 'badge bg-soft-secondary font-size-11';
      }
    },
    
    getBadgeIcon(status) {
      switch(status) {
        case 'online': return 'mdi mdi-check-circle';
        case 'offline': return 'mdi mdi-alert-circle';
        case 'warning': return 'mdi mdi-alert';
        default: return 'mdi mdi-help-circle';
      }
    },
    
    getStatusText(status) {
      switch(status) {
        case 'online': return 'Online';
        case 'offline': return 'Offline';
        case 'warning': return 'Aviso';
        default: return 'Desconhecido';
      }
    }
  }
};
</script>
